$(document)
  .on('focusin', '.skip_to_content', function focusin() {
    $(this).addClass('focusIn');
  })
  .on('focusout', '.skip_to_content', function focusout() {
    $(this).removeClass('focusIn');
  });
